export type BrowserType = 'chrome' | 'safari-mac' | 'safari-ios' | 'edge' | 'other';

export function detectBrowser(): BrowserType {
  const ua = navigator.userAgent;

  if (/Edg\//i.test(ua)) return 'edge';
  if (/Chrome\//i.test(ua)) return 'chrome';

  if (/Safari\//i.test(ua)) {
    const isTouch = navigator.maxTouchPoints > 1;
    return isTouch ? 'safari-ios' : 'safari-mac';
  }

  return 'other';
}
